import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navigation from './Navigation';
import Hero from './Hero';
import Journey from './Journey';
import Showcase from './Showcase';
import Contact from './Contact';
import Footer from './Footer';
import { ThemeProvider, useTheme } from './ThemeContext';

import ProjectsPage from './ProjectsPage';

const PortfolioContent = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);
  const [activeSection, setActiveSection] = useState('home');
  const { isDarkMode } = useTheme();

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  useEffect(() => {
    const handleScroll = () => {
      const totalScroll = document.documentElement.scrollTop;
      const windowHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      const scroll = `${totalScroll / windowHeight}`;

      setScrollProgress(scroll);

      // Determine active section
      const sections = ['home', 'showcase', 'journey', 'contact'];
      const navbarHeight = 128; // Adjust this value based on your navbar height

      for (let i = sections.length - 1; i >= 0; i--) {
        const section = document.getElementById(sections[i]);
        if (section) {
          const rect = section.getBoundingClientRect();
          if (rect.top <= navbarHeight) {
            setActiveSection(sections[i]);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const showcaseProjects = [
    { 
      title: 'GameCoder',
      description: 'AI-assisted game creation platform built for real classroom use. It helps students plan, build, and iterate on games through guided workflows instead of one-shot generation.',
      link: 'https://gamecoder.org'
    },
    { 
      title: 'StudentSafeChat',
      description: 'Teacher-controlled AI chat system designed for safe real-world classroom use, with visibility, oversight, and constraint-driven workflows built into the product from the start.',
      link: 'https://studentsafechat.com'
    },
    { 
      title: 'Image Explorer',
      description: 'Recently shipped classroom image exploration tool deployed on Vercel, built as a focused web app for working with visual material in an education context.',
      link: 'https://image-explorer-classroom.vercel.app'
    },
  ];

  return (
    <div className={`min-h-screen ${isDarkMode ? 'dark' : ''}`}>
      <div className="bg-white dark:bg-gray-900 text-gray-900 dark:text-white transition-colors duration-300">
        <Navigation toggleMenu={toggleMenu} isMenuOpen={isMenuOpen} activeSection={activeSection} />

        <div 
          className="fixed top-0 left-0 h-1 bg-gradient-to-r from-teal-400 to-teal-400 z-50 transition-all duration-300 ease-out"
          style={{ width: `${scrollProgress * 100}%` }}
        />

        <Routes>
          <Route path="/" element={
            <>
              <div id="home">
                <Hero />
              </div>
              <div id="showcase">
                <Showcase showcaseProjects={showcaseProjects} />
              </div>
              <div id="journey">
                <Journey />
              </div>
              <div id="contact">
                <Contact />
              </div>
            </>
          } />
          <Route path="/projects" element={<ProjectsPage />} />
        </Routes>

        <Footer />
      </div>
    </div>
  );
};

const PortfolioMain = () => (
  <Router>
    <PortfolioContent />
  </Router>
);

const ThemedPortfolioMain = () => (
  <ThemeProvider>
    <PortfolioMain />
  </ThemeProvider>
);

export default ThemedPortfolioMain;
